import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "../../../../CoreComponent/Select";
import toast from "react-hot-toast";
import Input from "../../../../CoreComponent/Input";
import "./style.scss";
import { Button, Grid } from "@mui/material";

const SponsorshipTable2 = () => {
  const [formData, setFormData] = useState({
    item: "",
    price: "",
    maxSponsors: "",
    booth_size: "",
    booklet_ad: "",
    website_ad: "",
    bags_inserts: "",
    backdrop_logo: "",
    non_residential_reg: "",
    residential_reg: "",
  });

  // Custom extra fields: user adds rows with (label + value)
  const [extras, setExtras] = useState([]); // [{ id, label, value }]

  const [allConference, setAllConference] = useState([]);
  const [conferenceId, setConferenceId] = useState("");
  const [videoShow, setVideoShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const getConference = () => {
    const url = `${BaseUrl}/conferences/all`;

    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAllConference(
          response.data.data?.map((item) => ({
            label: item?.title,
            value: item?.id,
          }))
        );
      })
      .catch(() => {
        setError("Error fetching conferences");
      });
  };

  useEffect(() => {
    getConference();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const addExtra = () => {
    setExtras((prev) => [
      ...prev,
      { id: Date.now() + Math.random(), label: "", value: "" },
    ]);
  };

  const updateExtra = (id, field, value) => {
    setExtras((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const deleteExtra = (id) => {
    setExtras((prev) => prev.filter((row) => row.id !== id));
  };

  const handlePostRequest = async () => {
    const con = conferenceId?.value;
    if (!con) {
      toast.error("Please select a conference");
      return;
    }

    if (!formData.item.trim() || !formData.price.trim() || !formData.maxSponsors.trim()) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);
    setError(null);

    const cleanedExtras = extras
      .map((x) => ({
        label: (x.label || "").trim(),
        value: x.value ?? "",
      }))
      .filter((x) => x.label !== "" || String(x.value).trim() !== "");

    // ✅ All fields now come from formData (user input)
    const dataToSend = {
      item: formData.item.trim(),
      price: formData.price.trim(),
      max_sponsors: parseInt(formData.maxSponsors) || 0,
      conference_id: parseInt(con),
      video_show_between_sessions: videoShow?.value || "no",
      booth_size: formData.booth_size.trim() || "",
      booklet_ad: formData.booklet_ad.trim() || "",
      website_ad: formData.website_ad.trim() || "",
      bags_inserts: formData.bags_inserts.trim() || "",
      backdrop_logo: formData.backdrop_logo.trim() || "",
      non_residential_reg: parseInt(formData.non_residential_reg) || 0,
      residential_reg: parseInt(formData.residential_reg) || 0,
      extras: cleanedExtras,
    };

    try {
      const response = await axios.post(`${BaseUrl}/sponsorship/add`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Sponsorship created successfully!");
      
      // Reset form
      setFormData({
        item: "",
        price: "",
        maxSponsors: "",
        booth_size: "",
        booklet_ad: "",
        website_ad: "",
        bags_inserts: "",
        backdrop_logo: "",
        non_residential_reg: "",
        residential_reg: "",
      });
      setConferenceId("");
      setVideoShow("");
      setExtras([]);
      setError(null);
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      const errorMsg = error.response?.data?.message || error.response?.data?.error || "Failed to create sponsorship";
      toast.error(errorMsg);
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const isFormEmpty =
    Object.values(formData).every((value) => value === "") && extras.length === 0;

  return (
    <div className="container-sponsorship-list">
      <div className="container-sponsorship-packages">
        {!isFormEmpty && (
          <div className="header-sponsorship-opportunities">
            Sponsorship Packages
          </div>
        )}

        {error && <p className="error">{error}</p>}

        <div className="form-container">
          <Select
            options={allConference}
            value={conferenceId}
            setValue={setConferenceId}
            label="Conference"
            placeholder="Select..."
          />

          <Select
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
            value={videoShow}
            setValue={setVideoShow}
            label="Video Show Between the Sessions"
            placeholder="Select..."
          />

          <Grid container spacing={2}>
  {/* Base fields */}
  {Object.keys(formData).map((key) => (
    <Grid item xs={12} sm={12} md={6} lg={4} key={key}>
      <Input
        label={key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase())
          .replace(/_/g, " ")}
        placeholder={`Enter ${key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toLowerCase())
          .replace(/_/g, " ")}`}
        inputValue={formData[key]}
        setInputValue={(value) =>
          handleInputChange({ target: { name: key, value } })
        }
        required={["item", "price", "maxSponsors"].includes(key)}
        errorMsg={error && error[key]}
      />
    </Grid>
  ))}

  {/* Custom extras rows – yeh button ke upar aa jayenge */}
  {extras.map((row) => (
    <Grid item xs={12} key={row.id}>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <div style={{ flex: 1 }}>
          <Input
            label="Extra Label"
            placeholder="Enter label (e.g., Booklet Ad)"
            inputValue={row.label}
            setInputValue={(v) => updateExtra(row.id, "label", v)}
          />
        </div>

        <div style={{ flex: 1 }}>
          <Input
            label="Extra Value"
            placeholder="Enter value"
            inputValue={row.value}
            setInputValue={(v) => updateExtra(row.id, "value", v)}
          />
        </div>

        <Button
          type="button"
          color="error"
          variant="outlined"
          onClick={() => deleteExtra(row.id)}
          sx={{ height: 36, marginTop: "10px" }}
        >
          Delete
        </Button>
      </div>
    </Grid>
  ))}

  {/* Add Extra button – sabse niche */}
  <Grid item xs={12}>
    <Button
      type="button"
      variant="outlined"
      onClick={addExtra}
      sx={{ width: "fit-content" }}
    >
      Add Extra
    </Button>
  </Grid>
</Grid>

        </div>

        <Button
          onClick={handlePostRequest}
          className="submit-button"
          disabled={loading}
          sx={{
            backgroundColor: "#e63946",
            marginTop: "20px",
            color: "#fff",
            width: "100%",
            "&:hover": {
              backgroundColor: "#c62828",
              color: "#fff",
            },
          }}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default SponsorshipTable2;